<template>
  <v-container class="mt-12 pt-8" style="background:#efefef;">
    <v-row style="background:#efefef;">
      <v-col cols="12" class="pa-0">

        <v-row class="py-1 px-5">
          <v-col cols="12" md="12">
            <v-row>
              <v-col cols="12" class="px-5" PANNELS>
                <v-card NotificationPanel :loading="loading">
                  <v-card-text class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="2" class="text-center" TITLE>
                            <v-icon size="40" color="secondary">people</v-icon>
                          </v-col>
                          <v-col cols="10" TITLE>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} black--text`">
                              {{ i18n[base] }}
                            </div>
                            <div :class="`${arabic ? 'arFont' : 'enFont'} grey--text`">
                              {{ i18n["manage_" + base] }}
                            </div>
                          </v-col>

                          <v-col cols="12" md="7">
                          </v-col>
                          <v-col cols="12" md="1">
                            <v-btn color="primary" text :class="`${arabic ? 'arFont' : 'enFont'}`"
                              @click="() => { newResource = {}; dialog = true }">new</v-btn>
                          </v-col>
                          <v-col cols="12" md="3">
                            <div>
                              <v-text-field v-model="search_term" :class="`${arabic ? 'arFont' : 'enFont'}`"
                                :label="i18n.search" outlined dense clearable hide-details>
                              </v-text-field>
                            </div>
                          </v-col>
                          <v-col cols="12" md="1">
                            <v-btn color="primary" text @click="filterUsers()"
                              :class="`${arabic ? 'arFont' : 'enFont'}`">
                              {{ i18n.search }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12">
                        <v-row class="align-center">
                          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                            <Paging :resourceSettings="resourceSettings" :resource="resource"
                              @loadResource="loadResource" @pageByNumber="pageByNumber" />
                          </v-col>
                          <v-col cols="12" :class="`${arabic ? 'arFont' : 'enFont'}`">
                            <v-expansion-panels focusable>
                              <v-expansion-panel v-for="(r, i) in resource.data" :key="'resource-' + i"
                                style="cursor:pointer;">
                                <v-expansion-panel-header class="py-0">
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="1" :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 font-weight-bold`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">
                                            <v-chip label x-small v-if="r.service" :class="`${arabic ? 'arFont' : 'enFont'}`">{{ r.service.label }}</v-chip>
                                          </span>
                                        </template>
                                        <div class="text-center">
                                          <div :class="`${arabic ? 'arFont' : 'enFont'}`" v-if="r.service">{{ r.service.name }}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="3"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-0 py-1 font-weight-bold`">
                                      <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                          <span v-bind="attrs" v-on="on">{{ r.label }}</span>
                                        </template>
                                        <div class="text-center">
                                          <div :class="`${arabic ? 'arFont' : 'enFont'}`">{{ r.name }}</div>
                                        </div>
                                      </v-tooltip>
                                    </v-col>
                                    <v-col cols="12" md="1">
                                      <v-btn color="info" x-small text @click="()=>{newResource = r;dialog=true;}">edit</v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content v-if="false">
                                  <v-divider class="pb-3"></v-divider>
                                  <v-row class="pa-0 align-center">
                                    <v-col cols="12" md="6" :class="`${arabic ? 'arFont' : 'enFont'} pa-1   text-left`">

                                    </v-col>
                                    <v-col cols="12" md="12"
                                      :class="`${arabic ? 'arFont' : 'enFont'} pa-1   text-left`">
                                      <v-btn color="success" block text @click="updateResource(r)">
                                        <v-icon left>save</v-icon>
                                        <span :class="`${arabic ? 'arFont' : 'enFont'}`">
                                          {{ i18n.update }}
                                        </span>
                                      </v-btn>
                                    </v-col>
                                  </v-row>
                                </v-expansion-panel-content>
                              </v-expansion-panel>
                            </v-expansion-panels>

                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-card-text>

                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <multiDialog :dialog="dialog" :loading="loading" :resourceSettings="resourceSettings" :deleting="deleting"
      :resourceKeys="resourceKeys" :newResource="newResource" @closeDialog="() => { dialog = false; newResource = {}; }"
      @deleteResource="deleteResource" @updateResource="updateResource" @postResource="postResource"
      @getUpload="getUpload" />
  </v-container>
</template>

<script>
import multiDialog from '@/components/multiDialog'
import Paging from '@/components/Paging'
import { format, render, cancel, register } from 'timeago.js';
import axios from 'axios';
const headers = { 'Accept': 'application/json' };
const fireapi = 'https://us-central1-innovation-evotik.cloudfunctions.net/main';

export default {
  components: { Paging, multiDialog },
  data() {
    return {
      loading: false,
      dialog: false,
      pdfreport: null,
      vresource: [],
      resource: [],
      search: null,
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      resourceKeys: [

      ],
      resourceSettings: {
        resourceName: null,
        search: false,
        create: false,
        pagination: true,
      },
      newResource: {},
      editing: false,
      deleting: false,
      newDialog: false,
      newUser: {},
      accounts: [],
      search_term: null,
    }
  },
  methods: {
    getInstituteHash(id) {
      return this.accounts.filter(x => x.id == id)[0].hash
    },
    getFormat(d) {
      return format(d)
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x => typeof x == 'string')
      let a = false
      v.forEach(x => {
        if (x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if (itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    clipboardSuccessHandler() {
      this.$emit('snackbarNotification', `Copied`, 'success')
    },
    clipboardErrorHandler() {
      this.$emit('snackbarNotification', `Failed`, 'error')
    },
    async pageByNumber(n) {
      return new Promise(async (res, rej) => {
        this.loading = true
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path, page: `?page=${n}` + this.buildFilter() })
          this.accounts = this.resource.accounts
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + `/search?page=${n}`, value: this.search })
        }
        this.loading = false
      })
    },
    goTo(path) {
      this.$router.push(path).catch(x => { })
    },
    buildFilter() {
      let filter = ``
      if (this.selectedAccount) {
        filter += `&filter[account]=${this.selectedAccount.id}`
      }
      if (this.search_term) {
        filter += `&filter[search]=${this.search_term}`
      }
      return filter
    },
    async filterUsers() {
      await this.loadResource()
    },
    firstLoad() {
      if (this.user) {
      }
    },
    async loadResource() {
      return new Promise(async (res, rej) => {
        this.loading = true
        if (!this.search) {
          this.resource = await this.$store.dispatch('getResource', { resource: this.$route.path + '?' + this.buildFilter() })
          console.log(this.resource)
        } else {
          this.resource = await this.$store.dispatch('searchResource', { resource: this.$route.path + '/search', value: this.search })
        }
        this.loading = false
        res()
      })
    },
    async updateResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        // console.log(r)
        await this.$store.dispatch('putResource', { resource: this.$route.path + `/${r.id}`, value: r })
        this.loadResource()
        this.loading = false
      })
    },
    async deleteResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        r.account_id = this.selectedAccount.id
        await this.$store.dispatch('deleteResource', { resource: this.resourceSettings.path + `/${r.id}` })
        this.dialog = false
        this.deleting = false
        this.loading = false
        this.newResource = {}
        await this.loadResource()
      })
    },
    async postResource(r) {
      return new Promise(async (res, rej) => {
        this.loading = true
        r.account_id = this.selectedAccount.id
        await this.$store.dispatch('postResource', { resource: this.resourceSettings.path + `${r.id ? '/' + r.id : ''}`, value: r })
        this.dialog = false
        this.loading = false
        this.newResource = {}
        await this.loadResource()
      })
    },
    showPannel(v) {
      this[v] = true
      let all = this.subitems.map(x => x.value)
      all.filter(x => x != v).forEach(x => this[x] = false)
    },
    setResourceName() {
      this.resourceSettings.resourceName = this.i18n[this.$route.path.replace('/', '')]
    },
    async setResourceSettings() {
      return new Promise(async (res, rej) => {
        this.resourceSettings = this.$store.state.resourceSettings[this.base]
        this.resourceKeys = this.$store.state.resourceKeys[this.base]
        this.resourceSettings.path = this.path
        this.resourceSettings.resourceName = this.base
        await this.loadItems(this.base)
        res(true)
      })
    },
    async loadItems(base) {
      return new Promise(async (res, rej) => {
        let ks = this.$store.state.resourceKeys[base].filter(x => x.type == 'select' && x.source == 'db');
        (async x => {
          for (let i = 0; i < ks.length; i++) {
            const f = ks[i];
            let t = this.resource[f.items]
            let maps = t.map(x => {
              let t = x.name ? x.name : null
              return { ...x, text: t, [`${f.name}`]: x.id }
            })
            f.data = maps
          }
          res(true)
        })()
      })
    },
    async init() {
      return new Promise(async (res) => {
        this.setResourceName()
        await this.loadResource()
        await this.setResourceSettings()
        res()
      })
    }
  },
  computed: {
    path() {
      return this.$route.path
    },
    base() {
      let base = this.path.replace('/', '')
      return base
    },
    sumRemainingSeats() {
      return this.$store.state.selectedAccount.plans.reduce((a, b) => a + b.users, 0) - this.resource.total
    },
    selectedAccount() {
      return this.$store.state.selectedAccount
    },
    checkDisabled() {
      if (this.user.role == 'master') {
        return false
      } else {
        return this.sumRemainingSeats > 0 ? false : true
      }
    },
    api() {
      return this.$store.state.settings.apiBase
    },
    users() {
      let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
      // console.log(sa)
      return this.$store.state.users.filter(x => {
        if (!sa) {
          return x.superior == this.$store.state.user.level
        } else return x
      })
    },
    site() {
      return this.$store.state.site
    },
    items() {
      return this.$store.state.menu
    },
    superAdmin() {
      return this.$store.state.superAdmin
    },
    isLogin() {
      return this.$store.state.centralLogin
    },
    language() {
      return this.$store.state.language
    },
    globalLoading() {
      return this.$store.state.globalLoading
    },
    user() {
      return this.$store.state.user
    },
    i18n() {
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic() {
      if (this.$store.state.language == 'ar') return true
    },
    routeTitle() {
      let main = this.$store.state.menu.filter(x => x.path == this.$route.path)
      let sub = [].concat(...this.$store.state.menu.map(x => x.subs)).filter(x => x).filter(x => x.path == this.$route.path)
      if (main.length) {
        return this.$store.state.i18n[this.$store.state.language][main[0].text]
      } else if (sub.length) {
        return this.$store.state.i18n[this.$store.state.language][sub[0].text]
      } else {
        return ''
      }
    },
    roles() {
      return this.$store.state.userRoles
    },
    notifications() {
      return this.$store.state.notifications.sort((a, b) => b.timestamp - a.timestamp)
    },
  },
  async created() {
    await this.init();

  },
}
</script>

<style>

</style>